/**
 * oatful-geo.js — v20
 * Fixes: Natively solves Shopify Grid layout gaps (pushes hidden DOM elements to back).
 * Fixes: Ensures lazyload images trigger properly by fixing DOM order.
 * Updates: Enhanced "intl-best-seller-only" tag logic.
 * Fixes: Prevents banner text and currency flicker, guarantees reveal with a failsafe.
 */
(function () {
  'use strict';

  var path = window.location.pathname.toLowerCase();
  var COUNTRY = '';

  /* 1. URL PATH PRECEDENCE (100% Accurate for Shopify Markets) */
  if      (path.indexOf('/sa') === 0 || path.indexOf('/en-sa') === 0 || path.indexOf('/ar-sa') === 0) COUNTRY = 'SA';
  else if (path.indexOf('/qa') === 0 || path.indexOf('/en-qa') === 0 || path.indexOf('/ar-qa') === 0) COUNTRY = 'QA';
  else if (path.indexOf('/om') === 0 || path.indexOf('/en-om') === 0 || path.indexOf('/ar-om') === 0) COUNTRY = 'OM';
  else if (path.indexOf('/kw') === 0 || path.indexOf('/en-kw') === 0 || path.indexOf('/ar-kw') === 0) COUNTRY = 'KW';
  else if (path.indexOf('/ae') === 0 || path.indexOf('/en-ae') === 0 || path.indexOf('/ar-ae') === 0) COUNTRY = 'AE';

  /* 2. SHOPIFY FALLBACK (Only if URL doesn't have a market subfolder) */
  if (!COUNTRY && window.Shopify && window.Shopify.country && window.Shopify.country !== 'US') {
    COUNTRY = window.Shopify.country;
  }

  /* 3. SHOGUN CACHE FALLBACK */
  if (!COUNTRY || COUNTRY === 'US') {
    try {
      var geo = window.localStorage.getItem('shg_geo_data');
      if (geo) {
        var parsed = JSON.parse(geo);
        if (parsed && parsed.country_code) COUNTRY = parsed.country_code;
        else if (parsed && parsed.country) COUNTRY = parsed.country;
      }
    } catch(e) {}
  }

  /* 4. TIMEZONE FALLBACK */
  if (!COUNTRY || COUNTRY === 'US') {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (tz === 'Asia/Dubai')  COUNTRY = 'AE';
      else if (tz === 'Asia/Riyadh') COUNTRY = 'SA';
      else if (tz === 'Asia/Qatar')  COUNTRY = 'QA';
      else if (tz === 'Asia/Muscat') COUNTRY = 'OM';
      else if (tz === 'Asia/Kuwait') COUNTRY = 'KW';
      else if (tz === 'Asia/Bahrain') COUNTRY = 'BH';
    } catch(e) {}
  }

  /* 5. ULTIMATE DEFAULT — keep AE since the main storefront is UAE-first.
     Kuwait and other GCC countries are caught by steps 1-4 via URL path,
     Shopify.country API, Shogun cache, or timezone detection. */
  if (!COUNTRY || COUNTRY === 'US') {
    COUNTRY = 'AE';
  }

  var IS_UAE    = COUNTRY === 'AE';
  var IS_INTL   = !IS_UAE && COUNTRY !== '';
  var LOCAL_CUR = { AE:'AED', SA:'SAR', QA:'QAR', OM:'OMR', KW:'KWD' }[COUNTRY] || 'USD';

  /* ════════════════════════════════════════════════════════════════════
   * IMMEDIATE CSS INJECTION
   * ════════════════════════════════════════════════════════════════════ */
  if (IS_INTL) {
    var _style = document.createElement('style');
    _style.id = 'oatful-geo-css';
    _style.textContent =
      '.grid__item[class*="-rte"],' +
      '.grid__item[class*="ready-to-eat"],' +
      '.grid__item.the-starter-pack-includes-ready-to-eat' +
      '{ display: none !important; }' +
      /* Hide Ready-to-Eat nav menu item (only inner dropdown li) for international markets */
      '.site-nav__dropdown li:has(a[href*="ready-to-eat"]) { display: none !important; }';
    (document.head || document.documentElement).appendChild(_style);
  }
  
  if (IS_UAE) {
    var _styleUae = document.createElement('style');
    _styleUae.id = 'oatful-geo-css-uae';
    _styleUae.textContent =
      '.grid__item[class*="ship-intl-only"]{ display: none !important; }';
    (document.head || document.documentElement).appendChild(_styleUae);
  }

  /* ════════════════════════════════════════════════════════════════════
   * TASK 1 — CURRENCY CONVERSION
   * ════════════════════════════════════════════════════════════════════ */
  var FX     = { SAR: 1.0211, QAR: 0.9911, OMR: 0.1048, USD: 0.2723 };
  var DHS_RE = /Dhs\.\s*([\d,]+\.?\d*)/g;

  function convertPrices() {
    if (!IS_INTL) return;
    var rate = FX[LOCAL_CUR] || 0.2723;

    var walker = document.createTreeWalker(
      document.body, NodeFilter.SHOW_TEXT,
      { acceptNode: function (node) {
          var tag = node.parentElement && node.parentElement.tagName;
          if (tag === 'SCRIPT' || tag === 'STYLE') return NodeFilter.FILTER_REJECT;
          return node.textContent.indexOf('Dhs.') !== -1
            ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      }, false
    );

    var nodes = [], n;
    while ((n = walker.nextNode())) { if (!n._oatfulDone) nodes.push(n); }

    nodes.forEach(function (node) {
      node._oatfulDone = true;
      DHS_RE.lastIndex = 0;
      node.textContent = node.textContent.replace(DHS_RE, function (match, amount) {
        var aed = parseFloat(amount.replace(/,/g, ''));
        if (isNaN(aed) || aed === 0) return match;
        return LOCAL_CUR + ' ' + Math.ceil(aed * rate);
      });
    });
  }

  /* ════════════════════════════════════════════════════════════════════
   * TASK 5 — HIDE EMPTY SECTIONS
   * ════════════════════════════════════════════════════════════════════ */
  function hideEmptySections() {
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function(section) {
      var links = section.querySelectorAll('a[href*="/products/"]');
      if (links.length === 0) return;

      var cards = [];
      links.forEach(function(link) {
        var c = findCard(link);
        if (c && cards.indexOf(c) === -1) cards.push(c);
      });

      if (cards.length === 0) return;

      var allHidden = cards.every(function(card) {
        return card.getAttribute('data-oatful-hidden') === '1' || window.getComputedStyle(card).display === 'none';
      });

      if (allHidden) {
        section.style.setProperty('display', 'none', 'important');
      }
    });
  }

  /* ════════════════════════════════════════════════════════════════════
   * TASK 3 — TAG-BASED PRODUCT HIDING
   * ════════════════════════════════════════════════════════════════════ */
  var _tagCache = {};

  function getProductTags(handle, cb) {
    if (Array.isArray(_tagCache[handle])) { cb(_tagCache[handle]); return; }
    if (_tagCache[handle] === 'pending') return;

    _tagCache[handle] = 'pending';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        _tagCache[handle] = p.tags || [];
        cb(_tagCache[handle]);
      })
      .catch(function () { _tagCache[handle] = []; cb([]); });
  }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function findCard(link) {
    var card = link.closest('.grid__item, .grid-product');
    if (!card) return null;
    var innerLinks = card.querySelectorAll('a[href*="/products/"]');
    if (innerLinks.length > 6) return null; 
    return card;
  }

  function hideCard(card) {
    if (!card || card.getAttribute('data-oatful-hidden')) return;
    card.setAttribute('data-oatful-hidden', '1');
    card.style.setProperty('display', 'none', 'important');
    
    if (card.parentElement) {
      card.parentElement.appendChild(card);
    }
  }

  function scanAndHideTaggedCards() {
    var links = document.querySelectorAll('a[href*="/products/"]:not([data-oatful-scanned])');
    var handles = {};

    links.forEach(function (link) {
      link.setAttribute('data-oatful-scanned', '1');
      var h = handleFromHref(link.getAttribute('href'));
      if (h) handles[h] = true;
    });

    Object.keys(handles).forEach(function (handle) {
      getProductTags(handle, function (tags) {
        var uaeOnly  = tags.indexOf('ship-uae-only')  !== -1;
        var intlOnly = tags.indexOf('ship-intl-only') !== -1;
        var intlBest = tags.indexOf('intl-best-seller-only') !== -1;
        
        document.querySelectorAll('a[href*="/products/' + handle + '"]')
          .forEach(function (link) {
            var card = findCard(link);
            if (!card) return;

            if ((IS_INTL && uaeOnly) || (IS_UAE && intlOnly)) {
              hideCard(card);
            }

            if (IS_UAE && intlBest) {
              var isBestSeller = false;
              var currentPath = window.location.pathname.toLowerCase();
              if (currentPath.indexOf('best-seller') !== -1 || currentPath.indexOf('bestseller') !== -1) {
                isBestSeller = true;
              }

              if (!isBestSeller) {
                var section = card.closest('.shopify-section, .collection, [id*="bestseller"], [id*="best-seller"]');
                if (section) {
                  var headings = section.querySelectorAll('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .title, .section-header__title');
                  for (var i = 0; i < headings.length; i++) {
                    var txt = headings[i].textContent.toLowerCase().replace(/[^a-z]/g, '');
                    if (txt.indexOf('bestseller') !== -1) {
                      isBestSeller = true;
                      break;
                    }
                  }
                }
              }

              if (isBestSeller) {
                hideCard(card);
              }
            }
          });
        
        hideEmptySections();
      });
    });
  }

  function guardProductPage() {
    var handle = handleFromHref(window.location.pathname);
    if (!handle) return;
    getProductTags(handle, function (tags) {
      if (IS_INTL && tags.indexOf('ship-uae-only')  !== -1) {
        document.documentElement.style.visibility = 'hidden';
        window.location.href = '/collections/all';
      }
      if (IS_UAE  && tags.indexOf('ship-intl-only') !== -1) {
        document.documentElement.style.visibility = 'hidden';
        window.location.href = '/collections/all';
      }
    });
  }

  /* ════════════════════════════════════════════════════════════════════
   * TASK 4 — BUNDLE OPTION HIDING
   * ════════════════════════════════════════════════════════════════════ */
  function hideBundleRefrigeratedOptions() {
    if (IS_UAE) return;

    // Only hide the group explicitly marked as the refrigerated "Ready to Eat"
    // group (see data-bundle-group="ready-to-eat" in product-var-grid.liquid).
    // This is heading-driven, not positional - "group 2" is Ready to Eat on
    // some bundle products (e.g. Custom Bundle) but Porridge Cup on others
    // (e.g. Starter Pack), so targeting a fixed class like .grid_bundle_2
    // wrongly hid Porridge/Cookies on products where Ready to Eat isn't group 2.
    document.querySelectorAll('[data-bundle-group="ready-to-eat"]').forEach(function (grid) {
      grid.style.setProperty('display', 'none', 'important');
      grid.querySelectorAll('input').forEach(function (inp) {
        inp.disabled = true; inp.checked = false;
      });
      var prev = grid.previousElementSibling;
      while (prev) {
        prev.style.setProperty('display', 'none', 'important');
        if (/^H[1-6]$/.test(prev.tagName)) break;
        prev = prev.previousElementSibling;
      }
    });
    document.querySelectorAll('[data-refrigerated="true"]').forEach(function (block) {
      block.style.setProperty('display', 'none', 'important');
      var inp = block.querySelector('input');
      if (inp) { inp.disabled = true; inp.checked = false; }
    });

    var COLD = ['ready-to-eat', 'refrigerated'];
    function isCold(s) {
      return COLD.some(function (kw) { return s.toLowerCase().indexOf(kw) !== -1; });
    }
    document.querySelectorAll('select option').forEach(function (opt) {
      if (isCold(opt.textContent)) opt.remove();
    });
    document.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (inp) {
      var lbl  = inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null;
      var text = (lbl ? lbl.textContent : '') || inp.value || '';
      if (!isCold(text)) return;
      var wrap = (lbl && lbl.closest('.bundle-option,.bundle-item,.product-option,li,div'))
                 || lbl || inp.parentElement;
      if (wrap) wrap.style.setProperty('display', 'none', 'important');
    });
  }

  /* ════════════════════════════════════════════════════════════════════
   * TASK 2 — GEO-TARGETED ANNOUNCEMENT BANNER
   * ════════════════════════════════════════════════════════════════════ */
  var BANNER_SLIDES = {
    AE: [
      '10% OFF YOUR FIRST ORDER IF YOU SUBSCRIBE TO OUR EMAIL',
      'SAME-DAY DELIVERY AVAILABLE IN DUBAI',
      'FREE STANDARD DELIVERY (1-3 DAYS) ON ORDERS ABOVE AED 250 | MADE IN UAE'
    ],
    SA: [
      '10% OFF YOUR FIRST ORDER IF YOU SUBSCRIBE TO OUR EMAIL',
      'DELIVERING TO KSA IN 3-5 DAYS'
    ],
    QA: [
      '10% OFF YOUR FIRST ORDER IF YOU SUBSCRIBE TO OUR EMAIL',
      'DELIVERING TO QATAR IN 3-5 DAYS'
    ],
    OM: [
      '10% OFF YOUR FIRST ORDER IF YOU SUBSCRIBE TO OUR EMAIL',
      'DELIVERING TO OMAN IN 3-5 DAYS',
      'FREE DELIVERY ON ORDERS ABOVE OMR 40'
    ],
    KW: [
      '10% OFF YOUR FIRST ORDER IF YOU SUBSCRIBE TO OUR EMAIL',
      'DELIVERING TO KUWAIT IN 3-5 DAYS'
    ]
  };

  // Function to smoothly reveal banners and prices after conversions are done
  function unhideElements() {
    // 1. Fade in Banners
    var desktopBanner = document.getElementById('oatful-announce-desktop');
    if (desktopBanner) desktopBanner.style.setProperty('opacity', '1', 'important');
    
    var mobileBanner = document.getElementById('oatful-announce-mobile');
    if (mobileBanner) mobileBanner.style.setProperty('opacity', '1', 'important');

    // 2. Fade in Prices
    document.querySelectorAll('span.money, .product-single__price, .product-single__sale-price, .gp-price, .gp-product-compare-price').forEach(function(el) {
        el.style.setProperty('opacity', '1', 'important');
    });

    // 3. Remove the protective shield from the DOM to allow standard behavior on subsequent interactions
    setTimeout(function() {
       var shield = document.getElementById('oatful-geo-shield');
       if (shield) shield.parentNode.removeChild(shield);
    }, 500);
  }

  function buildGeoSlider(id) {
    var slides  = BANNER_SLIDES[COUNTRY];
    if (!slides) return;
    
    var wrapper = document.getElementById(id);
    if (!wrapper) return;
    
    if (typeof $ !== 'undefined' && $(wrapper).hasClass('slick-initialized')) {
      $(wrapper).slick('unslick');
    }
    
    wrapper.innerHTML = slides.map(function (t) {
      return '<div class="oatful-slide" style="text-align:center;padding:0 12px;">' + t + '</div>';
    }).join('');
    
    if (typeof $ !== 'undefined' && typeof $.fn.slick === 'function') {
      $(wrapper).slick({ slidesToShow:1, slidesToScroll:1, autoplay:true, autoplaySpeed:3000, dots:false, arrows:false, fade:true });
    } else {
      var children = wrapper.children;
      if (children.length > 1) {
          for (var j = 1; j < children.length; j++) children[j].style.display = 'none';
          var i = 0;
          setInterval(function() {
              children[i].style.display = 'none';
              i = (i + 1) % children.length;
              children[i].style.display = 'block';
          }, 3000);
      }
    }
  }

  function initBanners() {
    buildGeoSlider('oatful-announce-desktop');
    buildGeoSlider('oatful-announce-mobile');
    unhideElements();
  }

  /* ════════════════════════════════════════════════════════════════════
   * INIT
   * ════════════════════════════════════════════════════════════════════ */
  function run() {
    convertPrices();
    scanAndHideTaggedCards();
    hideBundleRefrigeratedOptions();
    guardProductPage();
    hideEmptySections();

    if (typeof $ !== 'undefined') {
      $(document).ready(initBanners);
    } else {
      initBanners();
    }

    // Safety fallback: Unhide elements after 1 second no matter what happens
    setTimeout(unhideElements, 1000);

    var debounceTimer;
    var observer = new MutationObserver(function (mutations) {
      var hasNewProductLinks = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;
          if (node.matches && node.matches('a[href*="/products/"]:not([data-oatful-scanned])')) return true;
          if (node.querySelector) return !!node.querySelector('a[href*="/products/"]:not([data-oatful-scanned])');
          return false;
        });
      });

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        convertPrices();
        hideBundleRefrigeratedOptions();
        if (hasNewProductLinks) {
          scanAndHideTaggedCards();
        } else {
          hideEmptySections(); 
        }
      }, 400);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();